import { envConfig, EncryptMe } from '../_helpers';

export const companyService = {
  companyCreation,
  companyNotFinishedRemoval
}

async function companyCreation(company) {
  let encrypted = await EncryptMe(company);

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  return fetch(`${envConfig.MAIN_API_URL}/company/create`, requestOptions)
    .then(async(response) => {
      if ( response.status !== 200 ) {
        return Promise.reject(await response.json());
      }

      return response.json();
    })
    .then(company => {
      if ( company ) {
        return company.data;
      }
    })
}

async function companyNotFinishedRemoval(company) {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'req-language': 'pt_BR'
    }
  }

  const response = await fetch(`${envConfig.MAIN_API_URL}/company/notfinished/${company}`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}